// extracted by mini-css-extract-plugin
export default {"checks":"AdminCandidates_checks__hJLp1","check":"AdminCandidates_check__wZ9DR"};